/**
 * `"hair_mane"` -> `"Hair mane"`. Every slot code in this game is snake_case, and this is the
 * ONE place that turns one into a human label, so the wardrobe rail, its locked-slot hint, the
 * item drawer's sheet title, the equipment sheet and the bag's item-detail sheet always agree.
 *
 * <p>It lived in `wardrobe/SlotRail.tsx` (which re-exports it, so that module's own importers are
 * unchanged) until the bag's detail sheet needed to name a slot too. That sheet initially reached
 * for the EQUIPMENT slot table instead — which knows only the six functional slots and falls back
 * to the raw code — and printed `body_over` and `tail_wrap` at players for every cosmetic. Hence
 * the move: a labeller that only knows some slots is worse than no labeller, because it fails
 * silently on the rest.
 *
 * <p>WHY THIS IS NOT A LOOKUP TABLE. The 22 cosmetic slots are content (`content/packs/core.v1/
 * slots/cosmetic_slots.json`) and carry no display names — content packs may add more. A
 * transform covers every present and future code; a table would go stale the first time content
 * adds one, in exactly the silent way this defect already demonstrated. It is also correct for
 * all six equipment codes, which are single words (`weapon` -> `Weapon`).
 */
export function slotLabel(code: string): string {
  const words = code.split('_');
  return words[0].charAt(0).toUpperCase() + words[0].slice(1)
    + (words.length > 1 ? ' ' + words.slice(1).join(' ') : '');
}
